import { useToast } from 'modules/toast/hooks/useToast';
import { extractionError } from 'modules/toast/toastDictionary';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'shared/components/Button/Button';
import { ExtractionErrorOnboardingRedirectButton } from 'shared/components/ExtractionErrorOnboardingRedirectButton';
import { ModalContent } from 'shared/components/Modal/ModalContent';
import { useSitemap } from 'shared/hooks/useSitemap';
import { CrossIcon } from 'shared/icons';

interface ExtractionErrorModalProps {
  onClose: () => void;
}

export const ExtractionErrorModal: FC<ExtractionErrorModalProps> = ({ onClose }) => {
  const { t } = useTranslation();
  const sitemap = useSitemap();
  const { displayToast } = useToast();

  const handleCancel = useCallback(() => {
    displayToast(extractionError(t));
    onClose();
  }, [sitemap, onClose]);

  return (
    <ModalContent name="extractionErrorModal" className="max-w-[707px]">
      <div className="mb-6 flex flex-col items-center justify-center gap-3 md:flex-row md:gap-2">
        <div className="flex-center h-10 w-10 rounded-full bg-red/10 md:h-8 md:w-8">
          <CrossIcon className="h-5 w-5 text-red" />
        </div>
        <h3 className="text-center text-xl font-bold">{t('modal:extraction.error.title')}</h3>
      </div>
      <p className="mx-auto whitespace-pre-wrap text-center sm:text-base">
        {t('modal:extraction.error.description')}
      </p>
      <div className="mt-8 grid w-full gap-4 md:mt-12 md:grid-cols-2 md:gap-6">
        <Button
          variant="outline"
          color="black"
          name="extractionErrorCloseButton"
          onClick={handleCancel}
        >
          {t('modal:extraction.error.closeAction')}
        </Button>
        <ExtractionErrorOnboardingRedirectButton
          className="row-start-1 w-full md:row-start-auto"
          label={t('modal:extraction.error.confirmAction')}
          onRedirect={onClose}
        />
      </div>
    </ModalContent>
  );
};
